/**
 * @warn 这个hook会忽略第一次组件挂载时需要执行的函数
 */
import { useRef, useEffect } from 'react'
import type { EffectCallback, DependencyList } from 'react'

const useMounted = (fn?: EffectCallback, deps?: DependencyList) => {
  const isMounted = useRef<boolean>(false)

  useEffect(() => {
    if (isMounted.current) {
      return fn?.()
    }
    return undefined
  }, deps)

  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])

  return isMounted
}

export default useMounted
